/*

    Define and load custom Flex app themes here.

*/

const customTheme = require('./themes/theme-custom');

module.exports = {
    custom: customTheme,
};
